// import React, { useState } from 'react';

// import axios from 'axios';

// // import { useNavigate } from 'react-router-dom';

// const AdminPanel = () => {
//   // const navigate = useNavigate();
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

//   const [formData, setFormData] = useState({
//     username: '',
//     password: '',
//     department: '',
//     subjects: []
//   });
//   const [loading, setLoading] = useState(false);
//   const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);

//   const departments = ['AI', 'CSE', 'IT'];
//   const subjects = ['AI', 'ML', 'DS', 'DBMS'];

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubjectsChange = (subj) => {
//     const updatedSubjects = formData.subjects.includes(subj)
//       ? formData.subjects.filter(s => s !== subj)
//       : [...formData.subjects, subj];
//     setFormData({ ...formData, subjects: updatedSubjects });
//   };

//   const handleSubmit = async () => {
//     if (!formData.username || !formData.password || !formData.department) {
//       alert('Please fill in all required fields');
//       return;
//     }

//     setLoading(true);

//     try {
//       // Replace with your actual API call
//       const token = localStorage.getItem('token');
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/api/admin/add-teacher`,
//         formData,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       // Simulate API call
//       await new Promise(resolve => setTimeout(resolve, 2000));

//       setShowSuccessAnimation(true);
//       setTimeout(() => {
//         setShowSuccessAnimation(false);
//         setFormData({ username: '', password: '', department: '', subjects: [] });
//       }, 2000);

//     } catch (error) {
//       console.error('Error adding teacher:', error);
//       setSnackbar({
//         open: true,
//         message: error.response.data.message,
//         severity: 'error'
//       });
//       // alert('Error adding teacher');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGoBack = () => {
//     // Replace with your navigation logic
//     // navigate(-1);
//     console.log('Navigate back');
//   };


//   const closeSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };


//   return (
//     <div className="admin-container">
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
//         .admin-container {
//           min-height: 100vh;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           position: relative;
//           overflow: hidden;
//           padding: 2rem 1rem;
//           font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
//         }

//         .admin-container::before {
//           content: '';
//           position: absolute;
//           top: 10%;
//           left: 5%;
//           width: 80px;
//           height: 80px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.1);
//           animation: float 3s ease-in-out infinite;
//         }

//         .admin-container::after {
//           content: '';
//           position: absolute;
//           top: 60%;
//           right: 10%;
//           width: 120px;
//           height: 120px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.05);
//           animation: float 4s ease-in-out infinite;
//           animation-delay: 1s;
//         }

//         @keyframes float {
//           0%, 100% { transform: translateY(0px); }
//           50% { transform: translateY(-10px); }
//         }

//         @keyframes slideIn {
//           from { opacity: 0; transform: translateY(30px); }
//           to { opacity: 1; transform: translateY(0); }
//         }

//         @keyframes pulse {
//           0%, 100% { opacity: 0.4; }
//           50% { opacity: 0.8; }
//         }

//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }

//         @keyframes successPulse {
//           0% { transform: scale(1); opacity: 1; }
//           50% { transform: scale(1.1); opacity: 0.8; }
//           100% { transform: scale(1); opacity: 1; }
//         }

//         .pulse-element {
//           position: absolute;
//           bottom: 20%;
//           left: 20%;
//           width: 60px;
//           height: 60px;
//           border-radius: 50%;
//           background: rgba(255, 255, 255, 0.08);
//           animation: pulse 2s ease-in-out infinite;
//         }

//         .admin-wrapper {
//           max-width: 500px;
//           margin: 0 auto;
//           position: relative;
//           z-index: 1;
//         }

//         .back-button {
//           background: rgba(255, 255, 255, 0.15);
//           backdrop-filter: blur(10px);
//           border: 1px solid rgba(255, 255, 255, 0.2);
//           border-radius: 50%;
//           width: 50px;
//           height: 50px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           color: white;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           margin-bottom: 2rem;
//         }

//         .back-button:hover {
//           background: rgba(255, 255, 255, 0.25);
//           transform: translateX(-5px);
//         }

//         .header-section {
//           text-align: center;
//           margin-bottom: 3rem;
//         }

//         .header-chip {
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//           background: rgba(255, 255, 255, 0.15);
//           color: white;
//           padding: 0.5rem 1rem;
//           border-radius: 50px;
//           font-size: 0.9rem;
//           font-weight: 500;
//           margin-bottom: 1.5rem;
//           backdrop-filter: blur(10px);
//         }

//         .main-title {
//           font-size: clamp(2.5rem, 5vw, 3.5rem);
//           font-weight: 900;
//           color: white;
//           margin-bottom: 0.5rem;
//           text-shadow: 0 4px 20px rgba(0,0,0,0.3);
//           animation: slideIn 0.8s ease-out;
//         }

//         .gradient-text {
//           background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
//           -webkit-background-clip: text;
//           -webkit-text-fill-color: transparent;
//           background-clip: text;
//         }

//         .subtitle {
//           color: rgba(255, 255, 255, 0.9);
//           font-weight: 300;
//           font-size: 1.1rem;
//           animation: slideIn 0.8s ease-out 0.2s both;
//         }

//         .form-container {
//           background: rgba(255, 255, 255, 0.95);
//           backdrop-filter: blur(20px);
//           border-radius: 24px;
//           padding: 3rem 2.5rem;
//           border: 1px solid rgba(255, 255, 255, 0.2);
//           box-shadow: 0 20px 40px rgba(0,0,0,0.1);
//           animation: slideIn 0.8s ease-out 0.4s both;
//           position: relative;
//           overflow: hidden;
//         }

//         .form-container::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           height: 4px;
//           background: linear-gradient(90deg, #FE6B8B, #FF8E53, #4ECDC4, #667eea);
//           border-radius: 24px 24px 0 0;
//         }

//         .admin-icon {
//           width: 60px;
//           height: 60px;
//           background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           margin: 0 auto 2rem;
//           box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
//           color: white;
//         }

//         .form-title {
//           text-align: center;
//           font-size: 1.8rem;
//           font-weight: 700;
//           color: #1f2937;
//           margin-bottom: 2rem;
//         }

//         .form-group {
//           margin-bottom: 1.5rem;
//           position: relative;
//         }

//         .input-group {
//           position: relative;
//         }

//         .input-icon {
//           position: absolute;
//           left: 1rem;
//           top: 50%;
//           transform: translateY(-50%);
//           color: #6b7280;
//           z-index: 1;
//         }

//         .form-input {
//           width: 100%;
//           padding: 1rem 1rem 1rem 3rem;
//           border: 2px solid rgba(209, 213, 219, 0.3);
//           border-radius: 12px;
//           background: rgba(255, 255, 255, 0.9);
//           backdrop-filter: blur(10px);
//           font-family: inherit;
//           font-size: 1rem;
//           transition: all 0.3s ease;
//           outline: none;
//           box-sizing: border-box;
//         }

//         .form-input:focus {
//           border-color: #667eea;
//           box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
//           background: white;
//         }

//         .form-label {
//           display: block;
//           margin-bottom: 0.5rem;
//           font-weight: 600;
//           color: #374151;
//           font-size: 0.9rem;
//         }

//         .select-group {
//           position: relative;
//         }

//         .form-select {
//           width: 100%;
//           padding: 1rem;
//           border: 2px solid rgba(209, 213, 219, 0.3);
//           border-radius: 12px;
//           background: rgba(255, 255, 255, 0.9);
//           backdrop-filter: blur(10px);
//           font-family: inherit;
//           font-size: 1rem;
//           transition: all 0.3s ease;
//           outline: none;
//           appearance: none;
//           cursor: pointer;
//           box-sizing: border-box;
//         }

//         .form-select:focus {
//           border-color: #667eea;
//           box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
//           background: white;
//         }

//         .select-arrow {
//           position: absolute;
//           right: 1rem;
//           top: 50%;
//           transform: translateY(-50%);
//           pointer-events: none;
//           color: #6b7280;
//         }

//         .subjects-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
//           gap: 0.75rem;
//           margin-top: 0.5rem;
//         }

//         .subject-checkbox {
//           display: flex;
//           align-items: center;
//           padding: 0.75rem 1rem;
//           border: 2px solid rgba(209, 213, 219, 0.3);
//           border-radius: 12px;
//           background: rgba(255, 255, 255, 0.7);
//           cursor: pointer;
//           transition: all 0.3s ease;
//           font-size: 0.9rem;
//           font-weight: 500;
//         }

//         .subject-checkbox:hover {
//           border-color: #667eea;
//           background: rgba(102, 126, 234, 0.05);
//         }

//         .subject-checkbox.selected {
//           background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
//           color: white;
//           border-color: transparent;
//           box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
//         }

//         .checkbox-input {
//           margin-right: 0.5rem;
//           width: 16px;
//           height: 16px;
//         }

//         .submit-button {
//           width: 100%;
//           padding: 1rem 2rem;
//           background: linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%);
//           color: white;
//           border: none;
//           border-radius: 12px;
//           font-size: 1.1rem;
//           font-weight: 600;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           margin-top: 1rem;
//           position: relative;
//           overflow: hidden;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .submit-button:hover:not(:disabled) {
//           transform: translateY(-2px);
//           box-shadow: 0 12px 30px rgba(254, 107, 139, 0.4);
//         }

//         .submit-button:disabled {
//           opacity: 0.7;
//           cursor: not-allowed;
//           transform: none;
//         }

//         .loading-spinner {
//           width: 20px;
//           height: 20px;
//           border: 2px solid rgba(255, 255, 255, 0.3);
//           border-top: 2px solid white;
//           border-radius: 50%;
//           animation: spin 1s linear infinite;
//           margin-right: 0.5rem;
//         }

//         .success-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: rgba(16, 185, 129, 0.95);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 1000;
//           animation: slideIn 0.3s ease-out;
//         }

//         .success-content {
//           text-align: center;
//           color: white;
//           animation: successPulse 1s ease-in-out infinite;
//         }

//         .success-icon {
//           width: 80px;
//           height: 80px;
//           margin: 0 auto 1rem;
//           background: rgba(255, 255, 255, 0.2);
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 2.5rem;
//         }

//         .stats-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
//           gap: 1rem;
//           margin-bottom: 2rem;
//         }

//         .stat-item {
//           text-align: center;
//           padding: 1rem;
//           background: rgba(102, 126, 234, 0.05);
//           border-radius: 12px;
//           border: 1px solid rgba(102, 126, 234, 0.1);
//         }

//         .stat-number {
//           font-size: 1.5rem;
//           font-weight: 800;
//           color: #667eea;
//           margin-bottom: 0.25rem;
//         }

//         .stat-label {
//           font-size: 0.8rem;
//           color: #6b7280;
//           font-weight: 500;
//         }

//         /* Mobile responsiveness */
//         @media (max-width: 768px) {
//           .admin-container {
//             padding: 1rem 0.5rem;
//           }
          
//           .form-container {
//             padding: 2rem 1.5rem;
//           }
          
//           .subjects-grid {
//             grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
//           }
          
//           .main-title {
//             font-size: 2rem;
//           }
//         }
//       `}</style>

//       <div className="pulse-element"></div>

//       <div className="admin-wrapper">
//         {/* Back Button */}
//         <button className="back-button" onClick={handleGoBack}>
//           <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//             <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.42-1.41L7.83 13H20v-2z" />
//           </svg>
//         </button>

//         {/* Header Section */}
//         <div className="header-section">
//           <div className="header-chip">
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//               <path d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2M7.5,13A0.5,0.5 0 0,0 7,13.5A0.5,0.5 0 0,0 7.5,14A0.5,0.5 0 0,0 8,13.5A0.5,0.5 0 0,0 7.5,13M16.5,13A0.5,0.5 0 0,0 16,13.5A0.5,0.5 0 0,0 16.5,14A0.5,0.5 0 0,0 17,13.5A0.5,0.5 0 0,0 16.5,13Z" />
//             </svg>
//             Administrative Control Panel
//           </div>

//           <h1 className="main-title">
//             <span className="gradient-text">Admin</span> Dashboard
//           </h1>

//           <p className="subtitle">
//             Manage teachers and system resources
//           </p>
//         </div>

//         {/* Form Container */}
//         <div className="form-container">
//           <div className="admin-icon">
//             <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
//               <path d="M12,1L21,6V8H3V6L12,1M21,9A1,1 0 0,1 22,10V15A1,1 0 0,1 21,16H3A1,1 0 0,1 2,15V10A1,1 0 0,1 3,9H21M8,11V14H16V11H8Z" />
//             </svg>
//           </div>

//           <h2 className="form-title">Add New Teacher</h2>

//           {/* Quick Stats */}
//           <div className="stats-grid">
//             <div className="stat-item">
//               <div className="stat-number">24</div>
//               <div className="stat-label">Teachers</div>
//             </div>
//             <div className="stat-item">
//               <div className="stat-number">3</div>
//               <div className="stat-label">Departments</div>
//             </div>
//             <div className="stat-item">
//               <div className="stat-number">4</div>
//               <div className="stat-label">Subjects</div>
//             </div>
//           </div>

//           {/* Username Field */}
//           <div className="form-group">
//             <label className="form-label">Teacher Username</label>
//             <div className="input-group">
//               <div className="input-icon">
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
//                 </svg>
//               </div>
//               <input
//                 type="text"
//                 name="username"
//                 className="form-input"
//                 placeholder="Enter teacher username"
//                 value={formData.username}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//           </div>

//           {/* Password Field */}
//           <div className="form-group">
//             <label className="form-label">Teacher Password</label>
//             <div className="input-group">
//               <div className="input-icon">
//                 <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z" />
//                 </svg>
//               </div>
//               <input
//                 type="password"
//                 name="password"
//                 className="form-input"
//                 placeholder="Enter secure password"
//                 value={formData.password}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//           </div>

//           {/* Department Dropdown */}
//           <div className="form-group">
//             <label className="form-label">Department</label>
//             <div className="select-group">
//               <select
//                 name="department"
//                 className="form-select"
//                 value={formData.department}
//                 onChange={handleChange}
//                 required
//               >
//                 <option value="">Select Department</option>
//                 {departments.map(dept => (
//                   <option key={dept} value={dept}>{dept}</option>
//                 ))}
//               </select>
//               <div className="select-arrow">
//                 <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//                   <path d="M7,10L12,15L17,10H7Z" />
//                 </svg>
//               </div>
//             </div>
//           </div>

//           {/* Subjects Multi-Select */}
//           <div className="form-group">
//             <label className="form-label">Subjects ({formData.subjects.length} selected)</label>
//             <div className="subjects-grid">
//               {subjects.map(subj => (
//                 <div
//                   key={subj}
//                   className={`subject-checkbox ${formData.subjects.includes(subj) ? 'selected' : ''}`}
//                   onClick={() => handleSubjectsChange(subj)}
//                 >
//                   <input
//                     type="checkbox"
//                     className="checkbox-input"
//                     checked={formData.subjects.includes(subj)}
//                     readOnly
//                   />
//                   {subj}
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Submit Button */}
//           <button
//             className="submit-button"
//             disabled={loading}
//             onClick={handleSubmit}
//           >
//             {loading && <div className="loading-spinner"></div>}
//             {loading ? 'Adding Teacher...' : 'Add Teacher'}
//           </button>
//         </div>
//       </div>

//       {/* Success Overlay */}
//       {showSuccessAnimation && (
//         <div className="success-overlay">
//           <div className="success-content">
//             <div className="success-icon">
//               <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
//                 <path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" />
//               </svg>
//             </div>
//             <h2 style={{ margin: '0 0 0.5rem', fontSize: '2rem', fontWeight: '800' }}>
//               Teacher Added Successfully!
//             </h2>
//             <p style={{ margin: 0, fontSize: '1.1rem', opacity: 0.9 }}>
//               The new teacher account has been created
//             </p>
//           </div>
//         </div>
//       )}

//       {/* Snackbar Notification */}
//       {snackbar.open && (
//         <div className={`snackbar ${snackbar.severity}`}>
//           <span>{snackbar.message}</span>
//           <button className="snackbar-close" onClick={closeSnackbar}>
//             <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//               <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
//             </svg>
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminPanel;



import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AdminPanel = () => {
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [teacherStats, setTeacherStats] = useState({
    AI: 0,
    CSE: 0,
    ENTC: 0,
    Civil: 0,
    ME: 0,
    total: 0
  });

  const [formData, setFormData] = useState({
    username: '',
    password: '',
    department: '',
    subjects: []
  });
  const [loading, setLoading] = useState(false);
  const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);

  const departments = ['AI', 'CSE', 'ENTC', 'Civil', 'ME'];
  
  // All subjects data from register page
  const allSubjects = [
    // AI Department
    { dept: 'AI', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
    { dept: 'AI', year: 'I', sem: 'Sem-1', name: 'Physics' },
    { dept: 'AI', year: 'I', sem: 'Sem-1', name: 'Programming Basics' },
    { dept: 'AI', year: 'I', sem: 'Sem-2', name: 'Maths-2' },
    { dept: 'AI', year: 'I', sem: 'Sem-2', name: 'Data Structures' },
    { dept: 'AI', year: 'I', sem: 'Sem-2', name: 'Engineering Chemistry' },
    { dept: 'AI', year: 'II', sem: 'Sem-3', name: 'DBMS' },
    { dept: 'AI', year: 'II', sem: 'Sem-3', name: 'OOP in Java' },
    { dept: 'AI', year: 'II', sem: 'Sem-3', name: 'Discrete Mathematics' },
    { dept: 'AI', year: 'II', sem: 'Sem-4', name: 'Operating Systems' },
    { dept: 'AI', year: 'II', sem: 'Sem-4', name: 'Computer Networks' },
    { dept: 'AI', year: 'II', sem: 'Sem-4', name: 'AI Foundations' },
    { dept: 'AI', year: 'III', sem: 'Sem-5', name: 'Machine Learning' },
    { dept: 'AI', year: 'III', sem: 'Sem-5', name: 'Deep Learning' },
    { dept: 'AI', year: 'III', sem: 'Sem-6', name: 'NLP' },
    { dept: 'AI', year: 'III', sem: 'Sem-6', name: 'Big Data Analytics' },
    { dept: 'AI', year: 'IV', sem: 'Sem-7', name: 'AI Project' },
    { dept: 'AI', year: 'IV', sem: 'Sem-7', name: 'Cloud Computing' },
    { dept: 'AI', year: 'IV', sem: 'Sem-8', name: 'Capstone Project' },
    { dept: 'AI', year: 'IV', sem: 'Sem-8', name: 'AI Ethics' },

    // CSE Department
    { dept: 'CSE', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
    { dept: 'CSE', year: 'I', sem: 'Sem-1', name: 'Chemistry' },
    { dept: 'CSE', year: 'I', sem: 'Sem-2', name: 'C Programming' },
    { dept: 'CSE', year: 'I', sem: 'Sem-2', name: 'Maths-2' },
    { dept: 'CSE', year: 'II', sem: 'Sem-3', name: 'Data Structures' },
    { dept: 'CSE', year: 'II', sem: 'Sem-3', name: 'DBMS' },
    { dept: 'CSE', year: 'II', sem: 'Sem-4', name: 'OS' },
    { dept: 'CSE', year: 'II', sem: 'Sem-4', name: 'Computer Networks' },
    { dept: 'CSE', year: 'III', sem: 'Sem-5', name: 'Web Development' },
    { dept: 'CSE', year: 'III', sem: 'Sem-5', name: 'Software Engineering' },
    { dept: 'CSE', year: 'III', sem: 'Sem-6', name: 'Cloud Computing' },
    { dept: 'CSE', year: 'III', sem: 'Sem-6', name: 'Cyber Security' },
    { dept: 'CSE', year: 'IV', sem: 'Sem-7', name: 'Blockchain' },
    { dept: 'CSE', year: 'IV', sem: 'Sem-8', name: 'Final Year Project' },

    // ENTC Department
    { dept: 'ENTC', year: 'I', sem: 'Sem-1', name: 'Basic Electronics' },
    { dept: 'ENTC', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
    { dept: 'ENTC', year: 'I', sem: 'Sem-2', name: 'Signals & Systems' },
    { dept: 'ENTC', year: 'I', sem: 'Sem-2', name: 'Maths-2' },
    { dept: 'ENTC', year: 'II', sem: 'Sem-3', name: 'Digital Electronics' },
    { dept: 'ENTC', year: 'II', sem: 'Sem-3', name: 'Microprocessors' },
    { dept: 'ENTC', year: 'II', sem: 'Sem-4', name: 'Communication Engineering' },
    { dept: 'ENTC', year: 'II', sem: 'Sem-4', name: 'Electromagnetics' },
    { dept: 'ENTC', year: 'III', sem: 'Sem-5', name: 'Embedded Systems' },
    { dept: 'ENTC', year: 'III', sem: 'Sem-5', name: 'VLSI Design' },
    { dept: 'ENTC', year: 'III', sem: 'Sem-6', name: 'Internet of Things' },
    { dept: 'ENTC', year: 'IV', sem: 'Sem-7', name: 'Wireless Networks' },
    { dept: 'ENTC', year: 'IV', sem: 'Sem-8', name: 'Major Project' },

    // Civil Department
    { dept: 'Civil', year: 'I', sem: 'Sem-1', name: 'Engineering Mechanics' },
    { dept: 'Civil', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
    { dept: 'Civil', year: 'I', sem: 'Sem-2', name: 'Surveying' },
    { dept: 'Civil', year: 'II', sem: 'Sem-3', name: 'Strength of Materials' },
    { dept: 'Civil', year: 'II', sem: 'Sem-3', name: 'Building Materials' },
    { dept: 'Civil', year: 'II', sem: 'Sem-4', name: 'Hydraulics' },
    { dept: 'Civil', year: 'III', sem: 'Sem-5', name: 'Transportation Engineering' },
    { dept: 'Civil', year: 'III', sem: 'Sem-5', name: 'Geotechnical Engineering' },
    { dept: 'Civil', year: 'III', sem: 'Sem-6', name: 'Structural Analysis' },
    { dept: 'Civil', year: 'IV', sem: 'Sem-7', name: 'Irrigation Engineering' },
    { dept: 'Civil', year: 'IV', sem: 'Sem-8', name: 'Project & Estimation' },

    // Mechanical Department
    { dept: 'ME', year: 'I', sem: 'Sem-1', name: 'Engineering Mechanics' },
    { dept: 'ME', year: 'I', sem: 'Sem-2', name: 'Engineering Drawing' },
    { dept: 'ME', year: 'II', sem: 'Sem-3', name: 'Thermodynamics' },
    { dept: 'ME', year: 'II', sem: 'Sem-3', name: 'Fluid Mechanics' },
    { dept: 'ME', year: 'II', sem: 'Sem-4', name: 'Manufacturing Process' },
    { dept: 'ME', year: 'III', sem: 'Sem-5', name: 'Machine Design' },
    { dept: 'ME', year: 'III', sem: 'Sem-6', name: 'Heat Transfer' },
    { dept: 'ME', year: 'IV', sem: 'Sem-7', name: 'Robotics' },
    { dept: 'ME', year: 'IV', sem: 'Sem-8', name: 'Final Year Project' },
  ];

  // Fetch teacher statistics (mock data - replace with actual API call)
  useEffect(() => {
    const fetchTeacherStats = async () => {
      try {
        // Mock API call - replace with actual endpoint
        // const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/teacher-stats`);
        // setTeacherStats(response.data);
        
        // Mock data for demonstration
        const mockStats = {
          AI: 8,
          CSE: 12,
          ENTC: 6,
          Civil: 9,
          ME: 7,
          total: 42
        };
        setTeacherStats(mockStats);
      } catch (error) {
        console.error('Error fetching teacher stats:', error);
      }
    };

    fetchTeacherStats();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Reset subjects when department changes
    if (name === 'department') {
      setFormData({ ...formData, department: value, subjects: [] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubjectsChange = (subj) => {
    const updatedSubjects = formData.subjects.includes(subj)
      ? formData.subjects.filter(s => s !== subj)
      : [...formData.subjects, subj];
    setFormData({ ...formData, subjects: updatedSubjects });
  };

  const handleSubmit = async () => {
    if (!formData.username || !formData.password || !formData.department) {
      setSnackbar({
        open: true,
        message: 'Please fill in all required fields',
        severity: 'error'
      });
      return;
    }

    if (formData.subjects.length === 0) {
      setSnackbar({
        open: true,
        message: 'Please select at least one subject',
        severity: 'error'
      });
      return;
    }

    setLoading(true);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/admin/add-teacher`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setShowSuccessAnimation(true);
      
      // Update teacher stats
      setTeacherStats(prev => ({
        ...prev,
        [formData.department]: prev[formData.department] + 1,
        total: prev.total + 1
      }));

      setTimeout(() => {
        setShowSuccessAnimation(false);
        setFormData({ username: '', password: '', department: '', subjects: [] });
      }, 2000);

    } catch (error) {
      console.error('Error adding teacher:', error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || 'Error adding teacher',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleGoBack = () => {
    console.log('Navigate back');
  };

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Get unique subjects for selected department - moved here for better debugging
  const availableSubjects = React.useMemo(() => {
    if (!formData.department) return [];
    
    console.log('Department selected:', formData.department);
    console.log('All subjects array length:', allSubjects.length);
    
    const filtered = allSubjects.filter(subject => subject.dept === formData.department);
    console.log('Filtered subjects:', filtered);
    
    const subjectNames = filtered.map(subject => subject.name);
    const uniqueSubjects = [...new Set(subjectNames)];
    
    console.log('Unique subject names:', uniqueSubjects);
    return uniqueSubjects;
  }, [formData.department]);

  return (
    <div className="admin-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .admin-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .admin-container::before {
          content: '';
          position: absolute;
          top: 10%;
          left: 5%;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          animation: float 3s ease-in-out infinite;
        }

        .admin-container::after {
          content: '';
          position: absolute;
          top: 60%;
          right: 10%;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          animation: float 4s ease-in-out infinite;
          animation-delay: 1s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.8; }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes successPulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.1); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }

        .pulse-element {
          position: absolute;
          bottom: 20%;
          left: 20%;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: pulse 2s ease-in-out infinite;
        }

        .admin-wrapper {
          max-width: 600px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .back-button {
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-bottom: 2rem;
        }

        .back-button:hover {
          background: rgba(255, 255, 255, 0.25);
          transform: translateX(-5px);
        }

        .header-section {
          text-align: center;
          margin-bottom: 3rem;
        }

        .header-chip {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(255, 255, 255, 0.15);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
          margin-bottom: 1.5rem;
          backdrop-filter: blur(10px);
        }

        .main-title {
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 900;
          color: white;
          margin-bottom: 0.5rem;
          text-shadow: 0 4px 20px rgba(0,0,0,0.3);
          animation: slideIn 0.8s ease-out;
        }

        .gradient-text {
          background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .subtitle {
          color: rgba(255, 255, 255, 0.9);
          font-weight: 300;
          font-size: 1.1rem;
          animation: slideIn 0.8s ease-out 0.2s both;
        }

        .form-container {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 3rem 2.5rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          animation: slideIn 0.8s ease-out 0.4s both;
          position: relative;
          overflow: hidden;
        }

        .form-container::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #FE6B8B, #FF8E53, #4ECDC4, #667eea);
          border-radius: 24px 24px 0 0;
        }

        .admin-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;
          box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
          color: white;
        }

        .form-title {
          text-align: center;
          font-size: 1.8rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 2rem;
        }

        .form-group {
          margin-bottom: 1.5rem;
          position: relative;
        }

        .input-group {
          position: relative;
        }

        .input-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #6b7280;
          z-index: 1;
        }

        .form-input {
          width: 100%;
          padding: 1rem 1rem 1rem 3rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          font-family: inherit;
          font-size: 1rem;
          transition: all 0.3s ease;
          outline: none;
          box-sizing: border-box;
        }

        .form-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          background: white;
        }

        .form-label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: #374151;
          font-size: 0.9rem;
        }

        .select-group {
          position: relative;
        }

        .form-select {
          width: 100%;
          padding: 1rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          font-family: inherit;
          font-size: 1rem;
          transition: all 0.3s ease;
          outline: none;
          appearance: none;
          cursor: pointer;
          box-sizing: border-box;
        }

        .form-select:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          background: white;
        }

        .select-arrow {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          pointer-events: none;
          color: #6b7280;
        }

        .subjects-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 0.75rem;
          margin-top: 0.5rem;
          max-height: 300px;
          overflow-y: auto;
          padding: 1rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          background: rgba(249, 250, 251, 0.5);
        }

        .subject-checkbox {
          display: flex;
          align-items: center;
          padding: 0.75rem 1rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.7);
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .subject-checkbox:hover {
          border-color: #667eea;
          background: rgba(102, 126, 234, 0.05);
        }

        .subject-checkbox.selected {
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          color: white;
          border-color: transparent;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .checkbox-input {
          margin-right: 0.5rem;
          width: 16px;
          height: 16px;
        }

        .no-subjects-message {
          text-align: center;
          color: #6b7280;
          font-style: italic;
          padding: 2rem;
          background: rgba(243, 244, 246, 0.5);
          border-radius: 12px;
          margin-top: 0.5rem;
        }

        .submit-button {
          width: 100%;
          padding: 1rem 2rem;
          background: linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 1.1rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 1rem;
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .submit-button:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 12px 30px rgba(254, 107, 139, 0.4);
        }

        .submit-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .loading-spinner {
          width: 20px;
          height: 20px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-right: 0.5rem;
        }

        .success-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(16, 185, 129, 0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          animation: slideIn 0.3s ease-out;
        }

        .success-content {
          text-align: center;
          color: white;
          animation: successPulse 1s ease-in-out infinite;
        }

        .success-icon {
          width: 80px;
          height: 80px;
          margin: 0 auto 1rem;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2.5rem;
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .stat-item {
          text-align: center;
          padding: 1.5rem 1rem;
          background: rgba(102, 126, 234, 0.05);
          border-radius: 16px;
          border: 1px solid rgba(102, 126, 234, 0.1);
          position: relative;
          overflow: hidden;
        }

        .stat-item::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #667eea, #764ba2);
        }

        .stat-number {
          font-size: 2rem;
          font-weight: 800;
          color: #667eea;
          margin-bottom: 0.25rem;
        }

        .stat-label {
          font-size: 0.85rem;
          color: #6b7280;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .snackbar {
          position: fixed;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          padding: 1rem 2rem;
          border-radius: 12px;
          color: white;
          font-weight: 500;
          box-shadow: 0 8px 32px rgba(0,0,0,0.3);
          backdrop-filter: blur(10px);
          z-index: 1000;
          animation: slideIn 0.3s ease-out;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          max-width: 400px;
        }

        .snackbar.success {
          background: rgba(16, 185, 129, 0.9);
        }

        .snackbar.error {
          background: rgba(239, 68, 68, 0.9);
        }

        .snackbar.warning {
          background: rgba(245, 158, 11, 0.9);
        }

        .snackbar.info {
          background: rgba(59, 130, 246, 0.9);
        }

        .snackbar-close {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 4px;
          opacity: 0.8;
        }

        .snackbar-close:hover {
          opacity: 1;
          background: rgba(255, 255, 255, 0.1);
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .admin-container {
            padding: 1rem 0.5rem;
          }
          
          .form-container {
            padding: 2rem 1.5rem;
          }
          
          .subjects-grid {
            grid-template-columns: 1fr;
          }
          
          .main-title {
            font-size: 2rem;
          }

          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>

      <div className="pulse-element"></div>

      <div className="admin-wrapper">
        {/* Back Button */}
        <button className="back-button" onClick={handleGoBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.42-1.41L7.83 13H20v-2z" />
          </svg>
        </button>

        {/* Header Section */}
        <div className="header-section">
          <div className="header-chip">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2M7.5,13A0.5,0.5 0 0,0 7,13.5A0.5,0.5 0 0,0 7.5,14A0.5,0.5 0 0,0 8,13.5A0.5,0.5 0 0,0 7.5,13M16.5,13A0.5,0.5 0 0,0 16,13.5A0.5,0.5 0 0,0 16.5,14A0.5,0.5 0 0,0 17,13.5A0.5,0.5 0 0,0 16.5,13Z" />
            </svg>
            Administrative Control Panel
          </div>

          <h1 className="main-title">
            <span className="gradient-text">Admin</span> Dashboard
          </h1>

          <p className="subtitle">
            Manage teachers and system resources
          </p>
        </div>

        {/* Form Container */}
        <div className="form-container">
          <div className="admin-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12,1L21,6V8H3V6L12,1M21,9A1,1 0 0,1 22,10V15A1,1 0 0,1 21,16H3A1,1 0 0,1 2,15V10A1,1 0 0,1 3,9H21M8,11V14H16V11H8Z" />
            </svg>
          </div>

          <h2 className="form-title">Add New Teacher</h2>

          {/* Teacher Statistics */}
          {/* <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">{teacherStats.AI}</div>
              <div className="stat-label">AI Teachers</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{teacherStats.CSE}</div>
              <div className="stat-label">CSE Teachers</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{teacherStats.ENTC}</div>
              <div className="stat-label">ENTC Teachers</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{teacherStats.Civil}</div>
              <div className="stat-label">Civil Teachers</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{teacherStats.ME}</div>
              <div className="stat-label">ME Teachers</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{teacherStats.total}</div>
              <div className="stat-label">Total Teachers</div>
            </div>
          </div> */}

          {/* Username Field */}
          <div className="form-group">
            <label className="form-label">Teacher Username</label>
            <div className="input-group">
              <div className="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
                </svg>
              </div>
              <input
                type="text"
                name="username"
                className="form-input"
                placeholder="Enter teacher username"
                value={formData.username}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Password Field */}
          <div className="form-group">
            <label className="form-label">Teacher Password</label>
            <div className="input-group">
              <div className="input-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z" />
                </svg>
              </div>
              <input
                type="password"
                name="password"
                className="form-input"
                placeholder="Enter secure password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {/* Department Dropdown */}
          <div className="form-group">
            <label className="form-label">Department</label>
            <div className="select-group">
              <select
                name="department"
                className="form-select"
                value={formData.department}
                onChange={handleChange}
                required
              >
                <option value="">Select Department</option>
                {departments.map(dept => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </select>
              <div className="select-arrow">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7,10L12,15L17,10H7Z" />
                </svg>
              </div>
            </div>
          </div>

          {/* Subjects Multi-Select */}
          <div className="form-group">
            <label className="form-label">
              Subjects ({formData.subjects.length} selected)
              {formData.department && (
                <span style={{ color: '#10b981', marginLeft: '0.5rem', fontSize: '0.85rem' }}>
                  - {formData.department} Department ({availableSubjects.length} available)
                </span>
              )}
            </label>
            
            {!formData.department ? (
              <div className="no-subjects-message">
                Please select a department first to see available subjects.
              </div>
            ) : availableSubjects.length === 0 ? (
              <div className="no-subjects-message">
                No subjects available for the selected department: {formData.department}
                <br />
                <small>Debug: Check console for filtering details</small>
              </div>
            ) : (
              <div className="subjects-grid">
                {availableSubjects.map((subj, index) => (
                  <div
                    key={`${subj}-${index}`}
                    className={`subject-checkbox ${formData.subjects.includes(subj) ? 'selected' : ''}`}
                    onClick={() => handleSubjectsChange(subj)}
                  >
                    <input
                      type="checkbox"
                      className="checkbox-input"
                      checked={formData.subjects.includes(subj)}
                      readOnly
                    />
                    {subj}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Submit Button */}
          <button
            className="submit-button"
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading && <div className="loading-spinner"></div>}
            {loading ? 'Adding Teacher...' : 'Add Teacher'}
          </button>
        </div>
      </div>

      {/* Success Overlay */}
      {showSuccessAnimation && (
        <div className="success-overlay">
          <div className="success-content">
            <div className="success-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                <path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" />
              </svg>
            </div>
            <h2 style={{ margin: '0 0 0.5rem', fontSize: '2rem', fontWeight: '800' }}>
              Teacher Added Successfully!
            </h2>
            <p style={{ margin: 0, fontSize: '1.1rem', opacity: 0.9 }}>
              The new teacher account has been created for {formData.department} department
            </p>
          </div>
        </div>
      )}

      {/* Snackbar Notification */}
      {snackbar.open && (
        <div className={`snackbar ${snackbar.severity}`}>
          <span>{snackbar.message}</span>
          <button className="snackbar-close" onClick={closeSnackbar}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;